import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFormHexagon"><Path d="M10.5 3.11603C11.4282 2.58013 12.5718 2.58013 13.5 3.11603L18.9437 6.25897C19.872 6.79487 20.4437 7.78525 20.4437 8.85705V15.1429C20.4437 16.2147 19.872 17.2051 18.9437 17.741L13.5 20.884C12.5718 21.4199 11.4282 21.4199 10.5 20.884L5.05625 17.741C4.12805 17.2051 3.55625 16.2147 3.55625 15.1429V8.85705C3.55625 7.78525 4.12805 6.79487 5.05625 6.25897L10.5 3.11603Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFormHexagon;
